import { createUserManager } from 'redux-oidc';
import { env } from '../../helpers/env';
import Oidc from 'oidc-client';
console.log(env("IDENTITY_SERVER_URL"))
const userManagerConfig = {
  client_id: 'mvc',
  redirect_uri: window.location.origin + '/oidcCallback',
  response_type: 'token id_token',
  scope: 'openid profile bot-builder',
  authority: env("IDENTITY_SERVER_URL"),
  silent_redirect_uri: window.location.origin + '/silent_renew',
  post_logout_redirect_uri: window.location.origin,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  includeIdTokenInSilentRenew: false
};
const userManager = createUserManager(userManagerConfig);

export default userManager;
